import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const transportModeServiceApi = createApi({
  reducerPath: 'transportModeServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetTransportMode: builder.query<any, void>({
      query: () => 'transportmode',
    }),
  }),
});

export const { useLazyGetTransportModeQuery } = transportModeServiceApi;
